exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm-block__image[data-v-0b52238e]{display:flex;margin-bottom:32px}.confirm-block__title[data-v-0b52238e]{font-size:32px;line-height:35px;margin-bottom:16px}.confirm-block__text[data-v-0b52238e]{font-size:14px;line-height:18px}@media screen and (max-width:1279px){.confirm-block[data-v-0b52238e]{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}.confirm-block__title[data-v-0b52238e]{text-align:center}}@media screen and (max-width:1023px){.confirm-block__text[data-v-0b52238e]{text-align:center;max-width:180px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0b52238e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/templates/components/right-menu/ui/confirmBlock.vue
// module id = 515
// module chunks = 0